module.exports = __webpack_public_path__ + "88cf1660468d9421219d4a369c7c3652.webp";